<h2 mat-dialog-title>Passwort ändern</h2>

<form [formGroup]="form" (ngSubmit)="onSave()" class="dialog-form" autocomplete="off">
  <mat-dialog-content>

    <!-- Aktuelles Passwort -->
    <mat-form-field appearance="outline" class="full spaced">
      <mat-label>Aktuelles Passwort</mat-label>
      <input matInput [type]="showCurrent ? 'text' : 'password'" formControlName="currentPassword" cdkFocusInitial />
      <button mat-icon-button matSuffix type="button" (click)="showCurrent = !showCurrent" [attr.aria-label]="'Aktuelles Passwort anzeigen/verbergen'">
        <mat-icon>{{ showCurrent ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
      <mat-error *ngIf="form.get('currentPassword')?.hasError('required') && form.get('currentPassword')?.touched">
        Bitte aktuelles Passwort eingeben.
      </mat-error>
    </mat-form-field>

    <!-- Neues Passwort -->
    <mat-form-field appearance="outline" class="full spaced">
      <mat-label>Neues Passwort</mat-label>
      <input matInput [type]="showNew ? 'text' : 'password'" formControlName="newPassword" />
      <button mat-icon-button matSuffix type="button" (click)="showNew = !showNew" [attr.aria-label]="'Neues Passwort anzeigen/verbergen'">
        <mat-icon>{{ showNew ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
      <mat-hint align="start">Mindestens 8 Zeichen.</mat-hint>

      <mat-error *ngIf="form.get('newPassword')?.hasError('required') && form.get('newPassword')?.touched">
        Bitte neues Passwort eingeben.
      </mat-error>
      <mat-error *ngIf="form.get('newPassword')?.hasError('minlength') && form.get('newPassword')?.touched">
        Das Passwort ist zu kurz.
      </mat-error>
      <mat-error *ngIf="form.get('newPassword')?.hasError('sameAsCurrent') && form.get('newPassword')?.touched">
        Neues Passwort darf nicht dem aktuellen entsprechen.
      </mat-error>
    </mat-form-field>

    <!-- Bestätigung -->
    <mat-form-field appearance="outline" class="full spaced">
      <mat-label>Neues Passwort bestätigen</mat-label>
      <input matInput [type]="showConfirm ? 'text' : 'password'" formControlName="confirmPassword" />
      <button mat-icon-button matSuffix type="button" (click)="showConfirm = !showConfirm" [attr.aria-label]="'Bestätigung anzeigen/verbergen'">
        <mat-icon>{{ showConfirm ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>

      <mat-error *ngIf="form.get('confirmPassword')?.hasError('required') && form.get('confirmPassword')?.touched">
        Bitte die Passwortbestätigung eingeben.
      </mat-error>
      <mat-error *ngIf="form.get('confirmPassword')?.hasError('mismatch') && form.get('confirmPassword')?.touched">
        Die Bestätigung stimmt nicht mit dem neuen Passwort überein.
      </mat-error>
    </mat-form-field>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-stroked-button (click)="onCancel()">Abbrechen</button>
    <button type="submit" mat-flat-button color="primary" [disabled]="form.invalid">Speichern</button>
  </mat-dialog-actions>
</form>
